import currency from 'currency.js';

const PESO = value => currency(value, {
  symbol: '₱ ',
  precision: 2
});

export default class Currency {
  static pesoFormat(amount) {
    return PESO(amount).format();
  }

}
//# sourceMappingURL=currency.js.map